module.exports = __webpack_public_path__ + "fonts/AvenirLTStd-Roman.cc7d722c.woff";